<template>
  <div class="questionBank_info_list_set_type_10">
    <!-- 新增||编辑试题 - 设备采集 -->
    <el-form ref="questionData" :model="questionData" label-width="120px" size="mini" :rules="questionDataRules">
      <el-form-item label="题目内容" prop="questionName" class="form-item" style="width: 100%;">
        <el-input size="small" show-word-limit maxlength="200" type="textarea" resize="none" rows="3" clearable
          placeholder="请输入题目内容" v-model="questionData.questionName">
        </el-input>
      </el-form-item>
      <el-form-item label="考试内容" prop="examContent">
        <el-input show-word-limit maxlength="1000" type="textarea" resize="none" rows="4"
          v-model="questionData.examContent" clearable></el-input>
      </el-form-item>
      <el-form-item label="扣分标准" prop="evaluationStandard">
        <el-input show-word-limit maxlength="500" type="textarea" resize="none" rows="3"
          v-model="questionData.evaluationStandard" clearable></el-input>
      </el-form-item>
      <el-form-item label="配分" prop="score" class="form-item">
        <el-input-number v-model="questionData.score" :precision="1" :step="1" :min="0" :max="100"
          placeholder="请输入配分"></el-input-number>
      </el-form-item>
      <el-form-item label="考核设备标识" prop="serialPortDevice">
        <el-select v-model="questionData.serialPortDevice" clearable placeholder="请选择" style="width: 120px">
          <el-option v-for="item in serialPortDeviceList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="双人考核" prop="twoPersonSubmit" class="form-item" v-if="['21','22'].includes(questionData.serialPortDevice)">
        <el-switch v-model="questionData.twoPersonSubmit"></el-switch>
      </el-form-item>
      <el-form-item label="信号端子集合" prop="validPoint" class="form-item" v-if="['21','22'].includes(questionData.serialPortDevice)">
        <el-input size="small" show-word-limit maxlength="100" type="textarea" resize="none" rows="1" clearable
          placeholder="请输入信号端子集合" v-model="questionData.validPoint">
        </el-input>
      </el-form-item>
      <el-form-item label="标准答案" prop="standardAnswer" v-if="['21','22'].includes(questionData.serialPortDevice)">
        <el-input show-word-limit maxlength="1000" type="textarea" resize="none" rows="4"
          v-model="questionData.standardAnswer" clearable></el-input>
      </el-form-item>
      <el-form-item prop="tableData" class="form-item">
        <el-table ref="multipleTable" :data="tableData" :header-cell-style="tableHeader" size="small"
          tooltip-effect="dark" stripe style="width: 100%;">
          <el-table-column property="content" label="勾选否决项" width="80px" align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.veto"
                @change="(value) => checkTableData(value, scope.$index)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column property="content" label="选项内容" min-width="160" align="center">
            <template slot-scope="{ row }">
              <span style="font-size: 14px;display: inline-block;width: 20px;">{{ row.key }}.</span>
              <el-input v-model="row.content" placeholder="请输入选项内容"
                style="display: inline-block;width: calc(100% - 20px);"></el-input>
            </template>
          </el-table-column>
          <template v-if="['51'].includes(questionData.serialPortDevice)">
            <el-table-column property="serialPort" label="串口" min-width="100" align="center">
              <template slot-scope="{ row }">
                <el-input v-model="row.serialPort" placeholder="请输入串口"></el-input>
              </template>
            </el-table-column>
            <el-table-column property="device" label="地址" min-width="100" align="center">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.device" :precision="0" :step="1" :min="1" :max="32"
                  placeholder="请输入"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column property="signal" label="信号位" min-width="100" align="center">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.signal" :precision="0" :step="1" :min="0" :max="32"
                  placeholder="请输入"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column property="initialSignal" label="初始值" min-width="100" align="center">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.initialSignal" :precision="0" :step="1" :min="0" :max="1"
                  placeholder="请输入"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column property="targetSignal" label="目标值" min-width="100" align="center">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.targetSignal" :precision="0" :step="1" :min="0" :max="1"
                  placeholder="请输入"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column property="initialOperate" label="初始化提示" min-width="100" align="center">
              <template slot-scope="{ row }">
                <el-input v-model="row.initialOperate" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
          </template>
          <el-table-column property="score" label="扣除分值(分)" min-width="100" align="center">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.score" :precision="1" :step="1" :min="0" :max="100"
                placeholder="请输入"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="delRow(scope.$index)">删除选项</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="success" icon="el-icon-plus" size="mini" @click="addRow" style="margin-top: 10px;"
          :disabled="tableData.length > 20">添加选项</el-button>
      </el-form-item>
      <el-form-item class="btnBox">
        <el-button class="bgc-bv" @click="doClose">取消</el-button>
        <el-button class="bgc-bv" @click="getSure">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

import List from "@/mixins/List";
export default {
  name: "examinationAffairsManage_questionBank_info_list_set_type_10",
  components: {

  },
  props: {
    // 基本信息
    basicInfo: {
      bankId: "", // 题库id
      itemId: "", // 考核科目id
      subjectId: "", // 科目id
      itemCode: "", // 科目标识
      itemName: "", // 科目名称
      contentId: "", // 考核内容id
      questionId: "", // 考题id(编辑用)
      questionType: "", // 题目类型
    },
  },
  mixins: [List],
  data() {
    return {
      // 题目基础 - 数据
      questionData: {
        questionName: '',// 题目内容
        score: "", // 配分
        examContent: "", // 考核内容
        evaluationStandard: "", // 扣分标准
        serialPortDevice: "",   // 考核设备标识
        validPoint: "",         // 信号端子集合（逗号分割）
        standardAnswer: "",     // 标准答案，记录信号变化
        twoPersonSubmit: false,    // 是否双人作答
      },
      // 设备标识 - 下拉数据
      serialPortDeviceList: [],
      // 题目基础 - 数据 - 校验
      questionDataRules: {
        questionType: [
          { required: true, message: '请选择题目类型', trigger: 'change' }
        ],
        questionName: [
          { required: true, message: "请输入题目内容", trigger: "blur" },
        ],
        examContent: [
          { required: true, message: "请输入考核内容", trigger: "blur" },
        ],
        evaluationStandard: [
          { required: true, message: "请输入扣分标准", trigger: "blur" },
        ],
        score: [
          { required: true, message: "请输入配分", trigger: "blur" },
        ],
        serialPortDevice: [
          { required: true, message: "请选择配套考核设备", trigger: "blur" },
        ],
        validPoint: [
          { required: true, message: "请输入考题用到的信号端子集合", trigger: "blur" },
        ],
        standardAnswer: [
          { required: true, message: "请输入标准答案（信号变化规则)", trigger: "blur" },
        ]
      },
      // 选项列表数据
      tableData: [{
        key: 'A', // 选项
        content: '', // 内容
        img: '', // 图片地址
        serialPort: "", // 串口
        device: 1, // 地址
        signal: 1, // 信号位
        initialSignal: 1, // 初始信号位
        initialOperate: "", // 初始化提示
        targetSignal: 1, // 目标值
        score:"", // 分值
        veto: false, // 正确答案
      }],
    };
  },
  computed: {},
  mounted() {
  },
  created() {
    this.getDictionary();
    if (this.basicInfo.questionId) {
      this.getSubjectInfo();
    }
  },
  methods: {
    // 获取字典
    getDictionary() {
      // 审核状态
      let arr1 = this.$setDictionary("PA_SERIAL_PORT_DEVICE", "list");
      for (const key in arr1) {
        this.serialPortDeviceList.push({
          label: arr1[key],
          value: key,
        });
      }
    },
    // 获取 - 试题详情
    getSubjectInfo() {
      this.$post("/biz/bank/pa-question-bank/getQuestion", {
        questionId: this.basicInfo.questionId
      }, 3000, true, 10)
        .then((res) => {
          this.questionData = { ...this.questionData, ...res.data };
          delete this.questionData.optionJson;
          this.tableData = JSON.parse(res.data.optionJson);
          for (let index = 0; index <  this.tableData.length; index++) {
            const element = this.tableData[index];
            element.device = Number(this.tableData[index].device);
            element.signal = Number(this.tableData[index].signal);
            element.initialSignal = Number(this.tableData[index].initialSignal);
            element.targetSignal = Number(this.tableData[index].targetSignal);
          }
        })
        .catch((err) => {
          return;
        });
    },

    // 选项列表 - 删除选项
    delRow(index) {
      this.tableData.splice(index, 1)
      this.tableData.forEach((e, i) => {
        e.key = this.optionFM(i)
      })
    },
    // 选项列表 - 添加选项
    addRow(row) {
      this.tableData.push({
        key: this.optionFM(this.tableData.length),
        content: '', // 内容
        img: '', // 图片地址
        serialPort: "", // 串口
        device: 1, // 地址
        signal: 1, // 信号位
        initialSignal: 1, // 初始信号位
        initialOperate: "", // 初始化提示
        targetSignal: 1, // 目标值
        score:"", // 分值
        veto: false, // 正确答案
      })
    },
    // 选项列表 - 勾选 - 处理选项列表数据
    checkTableData(check, index) {

    },
    // 选项列表 - 图片上传
    handleAvatarSuccess2(res, file, row) {
      let extension = res.name.substring(
        res.name.lastIndexOf(".") + 1,
        res.name.length
      );
      let formData = new FormData();
      formData.append("file", res.raw);
      formData.append("fileType", extension);
      formData.append("folder", "PRACTICAL_QUESTION_BANK");
      formData.append("isPublic", false);
      const that = this;
      that
        .$Postformat("/sys/file/upload/url", formData, 3000, true, 10)
        .then((result) => {
          that.tableData.forEach((e, i) => {
            if (e.index == row.index) {
              row.img = result.data.fileUrl || "";
            }
          })
        })
        .catch((err) => {
          setTimeout(() => {
            that.$message({
              type: "warning",
              message: "上传失败",
            });
          }, 300);
        });
    },
    // 取消
    doClose() {
      this.$router.back();
    },
    // 保存
    getSure() {
      this.$refs['questionData'].validate((valid) => {
        let cOptionJson = []
        for (let i = 0; i < this.tableData.length; i++) {
          cOptionJson.push({
            ...this.tableData[i],
            device: String(this.tableData[i].device),
            signal: String(this.tableData[i].signal),
            initialSignal: String(this.tableData[i].initialSignal),
            targetSignal: String(this.tableData[i].targetSignal),
          })
        }
        cOptionJson = JSON.stringify(cOptionJson);
        if (valid) {
          let cData = {
            contentId: this.basicInfo.contentId, // 考核内容id
            questionId: this.basicInfo.questionId, // 考核内容id(有则编辑,无则添加)
            questionType: this.basicInfo.questionType, // 题目类型
            ...this.questionData,
            optionJson: cOptionJson
          }
          this.$post("/biz/bank/pa-question-bank/itemQuestionSaveUpdate", cData, 3000, true, 10)
            .then((res) => {
              this.$message.success('操作成功');
              this.$refs['questionData'].resetFields();
              this.questionData = this.$options.data().questionData;
              this.tableData = [{
                key: 'A', // 选项
                content: '', // 内容
                img: '', // 图片地址
                serialPort: "", // 串口
                device: 1, // 地址
                signal: 1, // 信号位
                initialSignal: 1, // 初始信号位
                initialOperate: "", // 初始化提示
                targetSignal: 1, // 目标值
                score:"", // 分值
                veto: false, // 正确答案
              }];
              // 编辑试题 - 编辑完自动返回上一页
              if (this.basicInfo.questionId) {
                this.doClose();
              }
            })
            .catch((err) => {
              return;
            });
        }
      })
    },
    // 选项顺序替换成字母
    optionFM(msg) {
      return String.fromCharCode('A'.charCodeAt(0) + msg);
    },
    // 选项字母替换成顺序
    optionFN(msg) {
      return msg.charCodeAt(0) - 'A'.charCodeAt(0);
    },
  },
};
</script>
<style lang="less" scoped>
.img-el-upload {
  margin: 0 auto;
  width: 88px;
  height: 88px;
}

/deep/.el-upload {
  width: 100%;
  height: 100%;
}

.up_video {
  width: 80px;

  /deep/ .el-upload {
    border: 0 !important;
  }
}

.upFileUrl {
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
  line-height: 20px;

  &:hover {
    cursor: pointer;
    color: #5c6be8;
  }
}
</style>
